import Model from './Model';

import Money from 'Api/Types/Money';

export default class UserAccountChange extends Model {
    readonly id: number;
    readonly createdAt: string;
    readonly type: string;
    readonly balanceName: string;
    readonly amount: Money;
    readonly currency: string;
    readonly balanceBefore: Money;
    readonly balanceAfter: Money;
    readonly detailsLink: string;

    constructor(data: Partial<UserAccountChange>) {
        super();
        this.assignDataToProps(data, [
            'id',
            'createdAt',
            'type',
            'balanceName',
            'amount',
            'currency',
            'balanceBefore',
            'balanceAfter',
            'detailsLink',
        ]);
    }
}
